/**
 * Detect Playwright / CI E2E runs so boot-recovery reloads do not interrupt tests.
 * Used by main.tsx, bootstrap, service worker recovery, and index.html (inline duplicate).
 */
export function isE2EMode(): boolean {
  if (typeof window === "undefined") return false;

  let mockForms: string | boolean | undefined;

  try {
    mockForms = import.meta.env.VITE_E2E_MOCK_FORMS;
    if (mockForms === "1" || mockForms === "true") return true;
    if (import.meta.env.CI === "true" || import.meta.env.CI === true) return true;
  } catch {
    /* ignore */
  }

  try {
    if (window.location.search.includes("e2e=1")) return true;
    if (sessionStorage.getItem("opus9:e2e-active")) return true;
    // Only treat localStorage role as E2E when this is an E2E mock build — bare DEV leftovers
    // must not suppress boot recovery or imply an E2E session for real logins.
    if (
      (mockForms === "1" || mockForms === "true") &&
      localStorage.getItem("__E2E_TEST_USER_ROLE__")
    ) {
      return true;
    }
  } catch {
    /* ignore storage access errors */
  }

  return false;
}
